module.exports = __webpack_public_path__ + "img/cuadros-con-detalles.9a5a3efc.png";